import { FC } from "react";
import { TaskAssignmentPayload } from "tm-shared/types";

import { GalleryUploader } from "@/components/GalleryUploader";
import { PhotoCaptions } from "@/types/common";

import { StyledBlock } from "../../Styled";

interface PhotoProps {
    marketId: string;
    title: string;
    payload: TaskAssignmentPayload;
    onUploadPhoto: (photo: string) => void;
    onDeletePhoto: (photoId: string) => void;

    captions: PhotoCaptions;
}

export const Photo: FC<PhotoProps> = ({
    marketId,
    title,
    payload,
    onUploadPhoto,
    onDeletePhoto,
    captions,
}) => {
    return (
        <StyledBlock>
            <GalleryUploader
                previewTitle={title}
                onUpload={onUploadPhoto}
                onDelete={onDeletePhoto}
                marketId={marketId}
                savedPhotos={payload?.photos ?? []}
                captionLines={captions}
            />
        </StyledBlock>
    );
};
